export default __webpack_public_path__ + "assets/models/e09ec475115e58ea8d37ad5be0fbd6c1.glb";